import { render, staticRenderFns } from "./LaunchIssues.vue?vue&type=template&id=2c34499d&scoped=true"
import script from "./LaunchIssues.vue?vue&type=script&lang=js"
export * from "./LaunchIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34499d",
  null
  
)

export default component.exports